import React from "react";

type TextareaProps = {
  label?: string;
  showLabel?: boolean;
  description?: string;
  showDescription?: boolean;
  placeholder?: string;
  value?: string;
  name?: string;
  id?: string;
  rows?: number;
  maxLength?: number;
  showCount?: boolean;
  disabled?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

const Textarea: React.FC<TextareaProps> = ({
  label,
  showLabel = true,
  description,
  showDescription = false,
  placeholder,
  value,
  name,
  id,
  rows = 4,
  maxLength,
  showCount = false,
  disabled = false,
  hasError = false,
  errorMessage,
  className,
  onChange,
}) => {
  return (
    <div className={`flex flex-col gap-1 ${className ?? ""}`}>
      {showLabel && label && (
        <label
          htmlFor={id}
          className="text-body-sm-emphasis text-[#303030]"
        >
          {label}
        </label>
      )}

      {showDescription && description && (
        <span className="text-xs text-gray">{description}</span>
      )}

      <div className="relative">
        <textarea
          id={id}
          name={name}
          rows={rows}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          onChange={onChange}
          className={`block w-full min-h-[80px] rounded-md border py-2 px-3 text-sm font-normal leading-5 text-[#303030] placeholder:text-[#A1A1AA] placeholder:font-normal focus:outline-none focus:border-[#1e3a5f] focus:ring-1 focus:ring-[#1e3a5f] transition-colors ${
            disabled ? "opacity-50 cursor-not-allowed bg-[#E8E8E8] text-[#6B6B6B]" : "bg-white"
          } ${
            hasError
              ? "border-red focus:border-red focus:ring-red"
              : "border-[#E8E8E8]"
          }`}
        />

        {showCount && maxLength && (
          <span className="absolute bottom-2 right-3 text-xs text-gray pointer-events-none">
            {value?.length ?? 0}/{maxLength}
          </span>
        )}
      </div>

      {hasError && errorMessage && (
        <span className="text-xs text-red">{errorMessage}</span>
      )}
    </div>
  );
};

export default Textarea;
